import { Sort } from '@angular/material/sort';

export class SetSort {
  static readonly type = '[RoleListState] SetSort';
  constructor(public readonly payload: Sort) {}
}
